import axios from "axios";
import { getCookie } from "../helpers/common";
import { addErrorLog } from "../Logger/logger";
import { toast } from "react-toastify";
import { getEnv } from "helpers/environment";
import { v4 as uuidv4 } from 'uuid';

export const handleFetchAuth0Token = async () => {
  return getCookie("accessToken") || "";
};

const executeFlowMakeRequest = async (data) => {
  const auth0Token = await handleFetchAuth0Token();

  try {
    const response = await axios({
      method: "post",
      url: getEnv("EXECUTOR_API"),
      maxBodyLength: Infinity,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Apollo-Require-Preflight": true,
        Authorization: "Bearer " + auth0Token,
        withCredentials: true,
        identifier: uuidv4()
      }
    });

    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      toast.error("Oops! Something went wrong on our end. We're working to fix it.", {});
    }
  }
};

const makeRequest = async (data) => {
  const accessToken = await handleFetchAuth0Token();

  try {
    const response = await axios({
      method: "post",
      // url: "http://localhost:4001/graphql",
      url: getEnv("EXECUTOR_API"),
      maxBodyLength: Infinity,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Apollo-Require-Preflight": true,
        Authorization: "Bearer " + accessToken,
        withCredentials: true
      }
    });

    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      toast.error("Oops! Something went wrong on our end. We're working to fix it.", {});

      throw new Error(error.message);
    }
    return { error: error.message };
  }
};

export const executeFlow = async (tenantId, input) => {
  const data = JSON.stringify({
    query: `mutation ExecuteFlow($tenantId: String!, $input: FlowInput) {
      executeFlow(tenantId: $tenantId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      input,
      tenantId
    }
  });

  try {
    const result = await executeFlowMakeRequest(data);

    if (result.error) {
      addErrorLog("mutation ExecuteFlow", result.error, tenantId);
    }

    return result?.executeFlow;
  } catch (error) {
    addErrorLog("mutation ExecuteFlow", error, tenantId);
    return null;
  }
};

export const cancelFlowExecution = async (tenantId, executionBatchDateTime) => {
  const data = JSON.stringify({
    query: `mutation CancelFlowExecution($tenantId: String!, $executionBatchDateTime: String!) {
      cancelFlowExecution(tenantId: $tenantId, executionBatchDateTime: $executionBatchDateTime) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      executionBatchDateTime
    }
  });

  try {
    const result = await makeRequest(data);
    return result?.cancelFlowExecution?.resultObject;
  } catch (error) {
    addErrorLog("mutation CancelFlowExecution", error, tenantId);
    return null;
  }
};

export const testCode = async (code, context) => {
  try {
    const data = JSON.stringify({
      query: `mutation TestCode($code: String!, $context: JSON) {
  testCode(code: $code, context: $context) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        code,
        context
      }
    });

    const result = await makeRequest(data);
    return result?.testCode;
  } catch (error) {
    addErrorLog("mutation TestCode", error);
    return null;
  }
};

export const redisTriggerSubscribe = async (tenant_id, flow_id, topics, credential_id) => {
  try {
    const data = JSON.stringify({
      query: `mutation RedisTriggerSubscribe($tenantId: String!, $flowId: ID!, $topics: [String], $credentialId: String) {
  redisTriggerSubscribe(tenant_id: $tenantId, flow_id: $flowId, topics: $topics, credential_id: $credentialId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
        flowId: flow_id,
        topics: topics,
        credentialId: credential_id
      }
    });
    const result = await makeRequest(data);
    return result?.redisTriggerSubscribe;
  } catch (error) {
    addErrorLog("mutation RedisTriggerSubscribe", error, tenant_id);
    return null;
  }
};

export const getConnectorConfigFile = async (url) => {
  try {
    const data = JSON.stringify({
      query: `query getConnectorConfigFile($url: String!) {
  getConnectorConfigFile(url: $url) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        url
      }
    });
    const result = await makeRequest(data);
    return result?.getConnectorConfigFile;
  } catch (error) {
    addErrorLog("query getConnectorConfigFile", error, url);
    return null;
  }
};

export const getConnectorVersionDownloadUrl = async (url) => {
  try {
    const data = JSON.stringify({
      query: `query ConnectorVersionDownloadUrl($url: String!) {
  connectorVersionDownloadUrl(url: $url) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        url
      }
    });
    const result = await makeRequest(data);
    return result?.connectorVersionDownloadUrl;
  } catch (error) {
    addErrorLog("query getConnectorVersionDownloadUrl", error, url);
    return null;
  }
};
